export enum CallBaseLogMessages {
  CALL_COMPLETE_SUCCESS = 'Call complete success',
  CALL_REJECTED_VI_LEFT_QUEUE = 'Call rejected and VI left queue',
  TAKE_CALL_CLICK = 'Take call click',
}
